 <template>
  <div>
    <v-dialog v-model="email_dialog" max-width="450" persistent>
      <v-card :loading="loading">
        <v-card-title class="headline">Send PDF Via Mail</v-card-title>
        <v-card-text>
          <v-row dense v-for="(row, index) in email_ids" :key="index">
            <v-col cols="11">
              <v-text-field
                label="Email Id"
                v-model="row.email"
                outlined
                dense
                hide-details=""
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="d-flex align-center justify-center">
              <v-icon :color="(index > 0)?'error':''" @click="addRemoveEmail(index)">{{(index > 0)?'mdi-close-circle':'mdi-plus-circle'}}</v-icon>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeDialog();">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            @click="send()"
            :loading="loading"
          >Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
 <script>
 export default {
  data() {
    return {
      loading: false,
      email_ids: []
    }
  },
  props: ['email_dialog', 'email_id'],
  watch: {
    email_dialog(val) {
      if(val) {
        this.loading = false
        this.email_ids = [
          {
            email: this.email_id
          }
        ]
      }
    }
  },
  computed: {
  },
  components: {
  },
   methods: {    
    addRemoveEmail(index) {
      if(index > 0) {
        this.email_ids.splice(index, 1)
      } else {
        this.email_ids.push({
          email: ''
        }) 
      }
    },
    closeDialog() {
      this.$emit('closeDialog');
    },
    send() {
      this.loading = true;
      this.$emit('sendMail', this.email_ids);
    }
  },
  created: function() {
  },
  mounted: function () {
  }
 }
 </script>